import { SupportedFileMimeTypes } from 'shared/domains/filesystem';
export const isPdf = (file) => file.type === SupportedFileMimeTypes.PDF;
export const isDocx = (file) => file.type === SupportedFileMimeTypes.DOCX;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent#description
const UNSUPPORTED_NON_ESCAPED_CHARACTERS = ["'", '!', '~', '*', '(', ')'];
export const filenameRegexp = new RegExp(`[${UNSUPPORTED_NON_ESCAPED_CHARACTERS.join('')}]+`, 'g');
